import { render, staticRenderFns } from "./LandingPageSection.vue?vue&type=template&id=0a1ed9a4"
import script from "./LandingPageSection.vue?vue&type=script&lang=js"
export * from "./LandingPageSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports